module.exports = __webpack_public_path__ + "img/bg_login_bck.fdd6851e.jpg";